import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GuestService } from 'app/layouts/guest-layout/_services/guestService.service';
import { AuthService } from 'app/modules/auth/_services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ValidateFormService } from '../helpers/validateForm.service';

@Component({
  selector: "app-guest-access",
  templateUrl: "./guest-access.component.html",
  styleUrls: ["./guest-access.component.scss"],
})
export class GuestAccessComponent implements OnInit {
  constructor(
    protected authService: AuthService,
    protected toast: ToastrService,
    protected router: Router,
    private fb: FormBuilder,
    private guestService: GuestService,
    private helperService: ValidateFormService
  ) {}
  accessForm: FormGroup;
  forgotForm: FormGroup;
  requestLoading: boolean;
  emailVerified: boolean;
  submitted: boolean;

  ngOnInit(): void {
    this.toggleModal("accessCodeModal", "open");
    // this.toggleModal("accessCodeModal", "open");
    this.initForm();
  }

  initForm() {
    this.accessForm = this.fb.group({
      guestCode: ["", [Validators.required]],
      // email: ["", [Validators.required, Validators.email]],
    });
    this.forgotForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  getErrorMessage(control: string, message: string) {
    return this.helperService.getError(this.accessForm.get(control), message);
  }
  isInvalid(control: string) {
    return (
      (this.accessForm.get(control)?.touched &&
        this.accessForm.get(control)?.invalid) ||
      (this.submitted && this.accessForm.get(control)?.invalid)
    );
  }
  getErrorMessageForgot(control: string, message: string) {
    return this.helperService.getError(this.forgotForm.get(control), message);
  }
  isInvalidForgot(control: string) {
    return (
      (this.forgotForm.get(control)?.touched &&
        this.forgotForm.get(control)?.invalid) ||
      (this.submitted && this.forgotForm.get(control)?.invalid)
    );
  }
  toggleModal = (modalId, action: string) => {
    if (action == "open") {
      document.getElementById(modalId).style.display = "flex";
    } else {
      document.getElementById(modalId).style.display = "none";
    }
  };

  closeCurrentModalAndOpenNewModal = (currentModalId, newModalId) => {
    this.toggleModal(currentModalId, "close");
    this.toggleModal(newModalId, "open");
  };

  eventId;
  receivingEmail: string = "";
  maskedEmail: string = "";
  savedGuestCode;
  loginToEvent() {
    this.requestLoading = true;
    const payload = {
      guestCode: this.accessForm.value.guestCode,
    };
    this.savedGuestCode = this.accessForm.value.guestCode;

    // const email = this.accessForm.value.email;
    this.guestService.guestLogin(payload).subscribe(
      (response) => {
        this.receivingEmail = response.receiving_email;
        this.maskedEmail = this.maskEmail(this.receivingEmail);
        this.requestLoading = false;
        if (response.success === true) {
          this.closeCurrentModalAndOpenNewModal(
            "accessCodeModal",
            "verifyEmailModal"
          );
          this.toggleModal("eventsModal", "close");
          this.toast.success("An OTP has been sent to your email!");
        } else {
          this.toast.error(response?.message);
        }
      },
      (error) => {
        this.requestLoading = false;
        // this.toast.error(error.error.message, "Unable to login as guest");
      }
    );
  }
  maskEmail(email: string): string {
    const [localPart, domain] = email.split("@");
    const maskedLocalPart = localPart.slice(0, 3) + "*******";
    return `${maskedLocalPart}@${domain}`;
  }
  guestDetails: any;
  eventDetails: any;
  // EMAIL MODAL METHODS
  verifyOTP = () => {
    this.requestLoading = true;
    const requestPayload = {
      email: this.receivingEmail,
      otp:
        this.input1.value +
        this.input2.value +
        this.input3.value +
        this.input4.value +
        this.input5.value +
        this.input6.value,
    };
    this.guestService.validateOTP(requestPayload).subscribe(
      (res: any) => {
        this.requestLoading = false;
        this.guestDetails = res["guestDetails"];
        this.eventDetails = res["eventDetails"];
        console.log(this.eventDetails);
        this.guestService.setGuestDetails(res);
        this.guestService.setGuestInfo(res["guestDetails"]);
        if (res.success) {
          this.toggleModal("verifyEmailModal", "close");
          this.gotoDashboard();
        } else {
          this.toast.error("Invalid OTP, please check and try again");
        }
      },
      (err) => {
        this.requestLoading = false;
        this.toast.error(err.error.message, "Error in validating OTP");
      }
    );
  };
  gotoDashboard() {
    this.toggleModal("guestAddedModal", "close");
    this.router.navigate([`/guest/event/${this.eventDetails._id}`]);
  }
  resendOTP = () => {
    this.requestLoading = true;
    this.guestService
      .resendGuestOTP({ guestCode: this.savedGuestCode })
      .subscribe(
        (res) => {
          this.requestLoading = false;
          this.accessForm.value.guestCode = "";
          this.toast.success("An OTP has been re-sent to your email");
        },
        (err) => {
          this.requestLoading = false;
          this.toast.error(err.error.message, "Error sending OTP");
        }
      );
  };
  capitalizeFirstLetter(text: string): string {
    return text?.charAt(0)?.toUpperCase() + text?.slice(1);
  }
  form = new FormGroup({
    input1: new FormControl("", Validators.required),
    input2: new FormControl("", Validators.required),
    input3: new FormControl("", Validators.required),
    input4: new FormControl("", Validators.required),
    input5: new FormControl("", Validators.required),
    input6: new FormControl("", Validators.required),
  });

  get input1() {
    return this.form.get("input1");
  }
  get input2() {
    return this.form.get("input2");
  }
  get input3() {
    return this.form.get("input3");
  }
  get input4() {
    return this.form.get("input4");
  }
  get input5() {
    return this.form.get("input5");
  }
  get input6() {
    return this.form.get("input6");
  }

  getCodeBoxElement(index) {
    return document.getElementById("codeBox" + index);
  }
  onKeyUpEvent(index, event) {
    const eventCode = event.which || event.keyCode;
    if (
      (this.getCodeBoxElement(index) as HTMLInputElement).value.length === 1
    ) {
      if (index !== 6) {
        this.getCodeBoxElement(index + 1).focus();
      } else {
        this.getCodeBoxElement(index).blur();
      }
    }
    if (eventCode === 8 && index !== 1) {
      this.getCodeBoxElement(index - 1).focus();
    }
  }
  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const currentElement = this.getCodeBoxElement(item);
      if (!(currentElement as HTMLInputElement).value) {
        currentElement.focus();
        break;
      }
    }
  }

  // END OF EMAIL MODAL METHODS
  events: any[] = [
    {
      type: "Wedding",
      name: "Invitte EOY Party",
      date: "2024-05-04",
      access: "private",
      price: 1000,
    },
    {
      type: "Birthday",
      access: "private",
      name: "John's 30th Birthday",
      date: "2024-07-15",
      price: 500,
    },
    {
      type: "Conference",
      name: "Tech Conference 2024 ",
      date: "2024-09-10",
      access: "public",
      price: 300,
    },
  ];
  getDay(dateStr: string): string {
    const date = new Date(dateStr);
    return date.getDate().toString();
  }

  getMonth(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleString("default", { month: "short" });
  }
  eventsError;
  eventsLoading;
  getGuestEvents() {
    this.eventsError = false;
    // this.eventsLoading = true;
    this.requestLoading = true;
    this.guestService.getGuestEvents(this.forgotForm.value.email).subscribe(
      (data: any) => {
        if (data.success) {
          this.events = data.data;
          if (this.events?.length > 0) {
            this.closeCurrentModalAndOpenNewModal("forgotModal", "eventsModal");
          }
        } else {
          this.toast.error("No guest events found for this email address");
        }
       
        // this.eventsLoading = false;
        this.requestLoading = false;
      },
      (error: any) => {
        this.requestLoading = false;
        this.toast.error(error.error.message);
        // this.eventsError = true;
      }
    );
  }

  loginAsGuest(guestCode: string) {
    // this.closeCurrentModalAndOpenNewModal("forgotModal", "eventsModal");
    this.accessForm.patchValue({
      guestCode: guestCode,
    });
    this.loginToEvent();
  }
}
